import SVGIconWrapper from "./SVGIconWrapper"

const IconChevronLeft = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 11 35"
        iconClass={`icon--chevron-left ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M11 1L9.2 0 0 17v1l9.2 17 1.8-1-9-16.5z" />
    </SVGIconWrapper>
)

export default IconChevronLeft